import BindoService from './base/bindoService'

function printerAssigned(printer, departmentId){
  let {kitchen_department_ids} = printer.details.send_to_kitchen
  // return kitchen_department_ids && kitchen_department_ids.includes(departmentId)
  return kitchen_department_ids && (kitchen_department_ids.indexOf(departmentId) >= 0)
}

class KitchenDepartmentService extends BindoService {
  async getAll(storeId){
    let kdPath = `v2/stores/${storeId}/kitchen_departments`
    let response = await super.get(kdPath, {per_page:999999})
    return response.data.map(({kitchen_department})=>kitchen_department)
  }
  async getPrinters(storeId){
    let path = `v2/stores/${storeId}/hardwares`
    let response = await super.get(path, {hardware_type: 'receipt_printer'})
    return response.hardwares
  }
  async getAllWithPrinter(storeId){
    let [departments, printers] = await Promise.all([
      this.getAll(storeId),
      this.getPrinters(storeId),
    ])
    departments = departments.map(kd=>{
      kd.printers = printers.filter(printer => printerAssigned(printer, kd.id))
      return kd
    })
    return {
      departments,
      printers,
    }
  }
  async create(storeId, department){
    let path = `v2/stores/${storeId}/kitchen_departments`
    let res = await super.post(path, {kitchen_department:department})
    return res.kitchen_department
  }
  async update(storeId, department){
    let path = `v2/stores/${storeId}/kitchen_departments/${department.id}`
    return await super.put(path, {kitchen_department:department})
  }
  assignPrinter(storeId, department){
    let promises = []
    for (let printer of department.printers){
      if (!printerAssigned(printer, department.id)){
        let path = `v2/stores/${storeId}/hardwares/${printer.id}`
        let { send_to_kitchen } = printer.details
        if (!send_to_kitchen.kitchen_department_ids){
          send_to_kitchen.kitchen_department_ids = []
        }
        send_to_kitchen.kitchen_department_ids.push(department.id)
        let p = super.put(path, {hardware:printer})
        promises.push(p)
      }
    }
    return Promise.all(promises)
  }
  async delete(storeId, departmentId){
    let path = `v2/stores/${storeId}/kitchen_departments/${departmentId}`
    return await super.delete(path)
  }
}

export default new KitchenDepartmentService()



/** WEBPACK FOOTER **
 ** ./client/services/kitchenDepartmentService.js
 **/